import queryString from 'query-string';
import { ApplicationSuccessType } from '../../models/ApplicationSuccessResult';
import { ApplicationResult } from '../../utilities/post-notification-handler';

type ExtendConsentResultArguments = {
  credentialsId: string;
};

export class ExtendConsentResult implements ApplicationResult {
  credentialsId: string;

  constructor({ credentialsId }: ExtendConsentResultArguments) {
    this.credentialsId = credentialsId;
  }

  buildQueryPath() {
    return queryString.stringify({
      credentialsId: this.credentialsId,
      credentials_id: this.credentialsId,
    });
  }

  buildIframeMessage() {
    return JSON.stringify({
      type: ApplicationSuccessType.NONE,
      data: this.credentialsId,
    });
  }
}
